import React from "react";
import styled, { keyframes } from "styled-components";
import { HeadingMunicipality, Caption } from "../../Util/StyleProps";
import BubbleFlexSvg from "../Elements/BubbleFlexSvg";
import { Col } from "react-bootstrap";
import { fadeIn, slideInUp } from "react-animations";
import { createMarkup } from "../../Helpers/CommonHelper";
import { scaleLinear } from "d3-scale";
import { secondaryColor } from "../../Util/Colors";

const slideInAnimation = keyframes`${slideInUp}`;
const fadeInAnimation = keyframes`${fadeIn}`;

const Wrapper = styled.div`
  // margin-top: -30px;
`;

const Svg = styled.svg`
  width: 100%;
`;

const SvgBottom = styled.svg`
  margin-top: 0;
`;

const G = styled.g``;

const Rect = styled.rect`
  height: ${props => props.height}px;
  width: ${props => props.width}px;
  animation: 0.75s ${props => (props.triggeranimation ? slideInAnimation : "")};
  animation-delay: ${props => props.delay}s;
  animation-fill-mode: both;
`;

const   SingleBarSvg = props => {
  const {
    valuePercentage,
    height,
    label,
    delay,
    triggerAnimation,
    color,
    title,
    titleId,
    lineType,
    caption,
    desc,
    descId,
    viewBoxWidth,
    viewBoxHeight,
    topSpace,
    maxOffset,
    hasBubbleBg,
    valueString,
    janne = 0
  } = props;

  const y = scaleLinear()
    .domain([0, maxOffset])
    .nice()
    .range([0, viewBoxHeight - topSpace]);

  const rectangleWidth = 50;
  return (
    <Wrapper>
      <Svg
        viewBox={`0 20 ${viewBoxWidth} ${viewBoxHeight - 20}`}
        // aria-labelledby={titleId + " " + descId}
      >
        {/* <title id={titleId}>{title}</title>
          <desc id={descId}>{desc}</desc> */}
        <G>
          <BubbleFlexSvg
            triggerAnimation={triggerAnimation}
            hasBackground={hasBubbleBg}
            delay={0.5 + delay}
            x={0}
            y={1.5+viewBoxHeight - topSpace * 0.8 - y(Number(valuePercentage))}
            label={label}
            value={valueString}
            lineType={lineType}
            width={"100%"}
            viewBoxWidth={100}
            viewBoxHeight={140}
            // hasLine={true}
          />
          <Rect
            triggeranimation={triggerAnimation}
            delay={delay}
            x={rectangleWidth * 0.5}
            y={viewBoxHeight - y(Number(valuePercentage))+ janne}
            height={triggerAnimation ? y(Number(valuePercentage)) : 0}
            fill={color}
            width={rectangleWidth}
          ></Rect>
        </G>
      </Svg>
      <Caption
        dangerouslySetInnerHTML={createMarkup(caption)}
        color={secondaryColor}
      ></Caption>
    </Wrapper>
  );
};

SingleBarSvg.defaultProps = {
  caption: "stapeltext",
  title: null,
  hasBubbleBg: true,
  lineType: null,
  topSpace: 90
};

export default SingleBarSvg;
